// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_asrt_apply = require("./MM_asrt_apply.bs.js");
var MM_proof_tree = require("./MM_proof_tree.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_substitution = require("./MM_substitution.bs.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function findAsrtParentsWithoutNewVars(tree, expr, restrictExprLen) {
  var exprLen = expr.length;
  var foundParents = [];
  Belt_MapString.forEach(MM_proof_tree.ptGetFrms(tree), (function (param, frm) {
          var frmExpr = frm.frame.asrt;
          if (Caml_array.get(frmExpr, 0) === Caml_array.get(expr, 0)) {
            MM_substitution.iterateSubstitutions(frmExpr, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, MM_proof_tree.ptGetParenCnt(tree), (function (subs) {
                    if (subs.isDefined.every(function (b) {
                            return b;
                          }) && MM_substitution.verifyDisjoints(frm.frame.disj, subs, (function (param, param$1) {
                              return MM_proof_tree.ptIsDisj(tree, param, param$1);
                            }))) {
                      var hyps = frm.frame.hyps;
                      var numOfArgs = hyps.length;
                      var args = new Array(numOfArgs);
                      var argsAreCorrect = true;
                      var argIdx = 0;
                      var maxArgIdx = numOfArgs - 1 | 0;
                      while(argIdx <= maxArgIdx && argsAreCorrect) {
                        var newExpr = MM_substitution.applySubs(Caml_array.get(hyps, argIdx).expr, subs, (function (param) {
                                throw {
                                      RE_EXN_ID: MM_parser.MmException,
                                      _1: {
                                        msg: "Work variables are not supported in addAsrtParentsWithoutNewVars()."
                                      },
                                      Error: new Error()
                                    };
                              }));
                        var tmp;
                        switch (restrictExprLen) {
                          case /* No */0 :
                              tmp = true;
                              break;
                          case /* LessEq */1 :
                              tmp = newExpr.length <= exprLen;
                              break;
                          case /* Less */2 :
                              tmp = newExpr.length < exprLen;
                              break;
                          
                        }
                        argsAreCorrect = tmp;
                        if (argsAreCorrect) {
                          Caml_array.set(args, argIdx, MM_proof_tree.ptGetOrCreateNode(tree, newExpr));
                        }
                        argIdx = argIdx + 1 | 0;
                      };
                      if (argsAreCorrect) {
                        foundParents.push({
                              TAG: /* Assertion */1,
                              args: args,
                              label: frm.frame.label,
                              frame: frm.frame
                            });
                      }
                      
                    }
                    return /* Continue */0;
                  }));
            return ;
          }
          
        }));
  return foundParents;
}

function proveFloating(tree, node) {
  if (!(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && !MM_proof_tree.pnIsInvalidFloating(node))) {
    return ;
  }
  var nodesToCreateParentsFor = Belt_MutableQueue.make(undefined);
  var savedNodes = Belt_HashSet.make(16, MM_context.ExprHash);
  var saveNodeToCreateParentsFor = function (node) {
    var match = MM_proof_tree.pnGetProof(node);
    if (match !== undefined || Belt_HashSet.has(savedNodes, MM_proof_tree.pnGetExpr(node))) {
      return ;
    } else {
      Belt_HashSet.add(savedNodes, MM_proof_tree.pnGetExpr(node));
      return Belt_MutableQueue.add(nodesToCreateParentsFor, node);
    }
  };
  saveNodeToCreateParentsFor(node);
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && !Belt_MutableQueue.isEmpty(nodesToCreateParentsFor)) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(curNode))) {
      var parents = MM_proof_tree.pnGetParents(curNode);
      if (parents !== undefined) {
        parents.forEach(function (parent) {
              if (typeof parent === "number") {
                return ;
              }
              if (parent.TAG === /* Hypothesis */0) {
                return ;
              }
              parent.args.forEach(saveNodeToCreateParentsFor);
            });
      } else {
        var curExpr = MM_proof_tree.pnGetExpr(curNode);
        if (MM_proof_tree.ptIsNewVarDef(tree, curExpr)) {
          MM_proof_tree.pnAddParent(curNode, /* VarType */0);
        } else {
          var hyp = MM_proof_tree.ptGetHypByExpr(tree, curExpr);
          if (hyp !== undefined) {
            MM_proof_tree.pnAddParent(curNode, {
                  TAG: /* Hypothesis */0,
                  label: hyp.label
                });
          } else {
            findAsrtParentsWithoutNewVars(tree, curExpr, /* LessEq */1).forEach((function(curNode){
                return function (parent) {
                  MM_proof_tree.pnAddParent(curNode, parent);
                  if (typeof parent === "number") {
                    return ;
                  }
                  if (parent.TAG === /* Hypothesis */0) {
                    return ;
                  }
                  parent.args.forEach(saveNodeToCreateParentsFor);
                }
                }(curNode)));
          }
        }
      }
    }
    
  };
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    return MM_proof_tree.pnSetInvalidFloating(node, true);
  }
  
}

function findAsrtParentsWithNewVars(tree, expr, stmts, exactOrderOfStmts, asrtLabel, allowEmptyArgs, allowNewVars, param) {
  var applResults = [];
  MM_asrt_apply.applyAssertions(MM_proof_tree.ptGetMaxVar(tree), MM_proof_tree.ptGetFrms(tree), (function (param, param$1) {
          return MM_proof_tree.ptIsDisj(tree, param, param$1);
        }), stmts, exactOrderOfStmts, allowEmptyArgs, expr, MM_proof_tree.ptGetParenCnt(tree), (function (frame) {
          return Belt_Option.getWithDefault(Belt_Option.map(asrtLabel, (function (asrtLabel) {
                            return frame.label === asrtLabel;
                          })), true);
        }), (function (res) {
          if (allowNewVars || res.newVars.length === 0) {
            applResults.push(res);
          }
          return /* Continue */0;
        }), undefined, undefined);
  var foundParents = [];
  applResults.forEach(function (applResult) {
        var applNewVarToTreeNewVar = Belt_MutableMapInt.make(undefined);
        applResult.newVars.forEach(function (applResNewVar, i) {
              var newVarType = Caml_array.get(applResult.newVarTypes, i);
              var treeNewVar = MM_proof_tree.ptAddNewVar(tree, newVarType);
              Belt_MutableMapInt.set(applNewVarToTreeNewVar, applResNewVar, treeNewVar);
            });
        MM_context.disjForEach(applResult.newDisj, (function (n, m) {
                MM_proof_tree.ptAddDisjPair(tree, Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, n, n), Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, m, m));
              }));
        var frm = Belt_MapString.get(MM_proof_tree.ptGetFrms(tree), applResult.asrtLabel);
        var frame;
        if (frm !== undefined) {
          frame = frm.frame;
        } else {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot find an assertion with label " + applResult.asrtLabel + " in findParentsWithNewVars."
                },
                Error: new Error()
              };
        }
        var numOfArgs = frame.hyps.length;
        var args = new Array(numOfArgs);
        var typesAreCorrect = true;
        var argIdx = 0;
        var maxArgIdx = numOfArgs - 1 | 0;
        while(argIdx <= maxArgIdx && typesAreCorrect) {
          var argExpr = MM_substitution.applySubs(Caml_array.get(frame.hyps, argIdx).expr, applResult.subs, (function (param) {
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "New work variables are not expected here [findParentsWithNewVars]."
                        },
                        Error: new Error()
                      };
                }));
          var maxI = argExpr.length - 1 | 0;
          for(var i = 0; i <= maxI; ++i){
            Caml_array.set(argExpr, i, Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, Caml_array.get(argExpr, i), Caml_array.get(argExpr, i)));
          }
          var argNode = MM_proof_tree.ptGetOrCreateNode(tree, argExpr);
          Caml_array.set(args, argIdx, argNode);
          if (Caml_array.get(frame.hyps, argIdx).typ === /* F */0) {
            proveFloating(tree, argNode);
            typesAreCorrect = Belt_Option.isSome(MM_proof_tree.pnGetProof(argNode));
          }
          argIdx = argIdx + 1 | 0;
        };
        if (typesAreCorrect) {
          foundParents.push({
                TAG: /* Assertion */1,
                args: args,
                label: applResult.asrtLabel,
                frame: frame
              });
          return ;
        }
        
      });
  return foundParents;
}

function proveWithoutJustification(tree, expr) {
  var node = MM_proof_tree.ptGetOrCreateNode(tree, expr);
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    var parents = findAsrtParentsWithNewVars(tree, expr, MM_proof_tree.ptGetRootStmts(tree).map(function (stmt) {
              return stmt.expr;
            }), false, undefined, false, false, undefined);
    Expln_utils_common.arrForEach(parents, (function (parent) {
            MM_proof_tree.pnAddParent(node, parent);
            return MM_proof_tree.pnGetProof(node);
          }));
  }
  return node;
}

function getStatementsFromJustification(tree, jstf) {
  var getStmtByLabel = function (label) {
    var stmt = MM_proof_tree.ptGetRootStmts(tree).find(function (stmt) {
          return stmt.label === label;
        });
    if (stmt !== undefined) {
      return stmt.expr;
    }
    var hyp = MM_proof_tree.ptGetHypByLabel(tree, label);
    if (hyp !== undefined) {
      return hyp.expr;
    }
    
  };
  var foundStmts = jstf.args.map(getStmtByLabel).filter(Belt_Option.isSome).map(Belt_Option.getExn);
  if (foundStmts.length === jstf.args.length) {
    return foundStmts;
  }
  
}

function proveWithJustification(tree, expr, jstf) {
  var node = MM_proof_tree.ptGetOrCreateNode(tree, expr);
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    var args = getStatementsFromJustification(tree, jstf);
    if (args !== undefined) {
      var parents = findAsrtParentsWithNewVars(tree, expr, args, true, jstf.asrt, false, false, undefined);
      Expln_utils_common.arrForEach(parents, (function (parent) {
              MM_proof_tree.pnAddParent(node, parent);
              return MM_proof_tree.pnGetProof(node);
            }));
    }
    
  }
  return node;
}

function srcIsBackRef(expr, src) {
  if (typeof src === "number" || src.TAG === /* Hypothesis */0) {
    return false;
  } else {
    return src.args.some(function (arg) {
                return MM_context.exprEq(expr, MM_proof_tree.pnGetExpr(arg));
              });
  }
}

function proveBottomUp(tree, expr, getParents, maxSearchDepth, onProgress) {
  Belt_Option.forEach(onProgress, (function (onProgress) {
          Curry._1(onProgress, "Proving bottom-up: initialization");
        }));
  var nodesToCreateParentsFor = Belt_MutableQueue.make(undefined);
  var maxSearchDepthStr = String(maxSearchDepth);
  var progressState = MM_progress_tracker.progressTrackerMutableMake(0.01, undefined, (function (param) {
          
        }), undefined, undefined);
  MM_proof_tree.ptClearDists(tree);
  var rootNode = MM_proof_tree.ptGetOrCreateNode(tree, expr);
  MM_proof_tree.pnSetDist(rootNode, 0);
  Belt_MutableQueue.add(nodesToCreateParentsFor, rootNode);
  var lastDist = 0;
  var maxCnt = 1;
  var cnt = 0;
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(rootNode)) && !Belt_MutableQueue.isEmpty(nodesToCreateParentsFor)) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(curNode))) {
      var dist = MM_proof_tree.pnGetDist(curNode);
      var curDist;
      if (dist !== undefined) {
        curDist = dist;
      } else {
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Encountered a node without dist."
              },
              Error: new Error()
            };
      }
      if (onProgress !== undefined) {
        if (lastDist !== curDist) {
          lastDist = curDist;
          var curDistStr = String(curDist);
          progressState = MM_progress_tracker.progressTrackerMutableMake(0.01, undefined, (function(curDistStr){
              return function (pct) {
                var pctStr = String(Math.round(pct * 100) | 0);
                Curry._1(onProgress, "Proving bottom-up: " + curDistStr + "/" + maxSearchDepthStr + " " + pctStr + "%");
              }
              }(curDistStr)), undefined, undefined);
          maxCnt = Belt_MutableQueue.size(nodesToCreateParentsFor) + 1 | 0;
          cnt = 0;
        }
        MM_progress_tracker.progressTrackerMutableSetCurrPct(progressState, cnt / maxCnt);
        cnt = cnt + 1 | 0;
      }
      var curExpr = MM_proof_tree.pnGetExpr(curNode);
      if (MM_proof_tree.ptIsNewVarDef(tree, curExpr)) {
        MM_proof_tree.pnAddParent(curNode, /* VarType */0);
      } else {
        var hyp = MM_proof_tree.ptGetHypByExpr(tree, curExpr);
        if (hyp !== undefined) {
          MM_proof_tree.pnAddParent(curNode, {
                TAG: /* Hypothesis */0,
                label: hyp.label
              });
        } else {
          var newDist = curDist + 1 | 0;
          if (newDist <= maxSearchDepth) {
            Curry._2(getParents, curExpr, curDist).forEach((function(curNode,curExpr,newDist){
                return function (src) {
                  if (srcIsBackRef(curExpr, src)) {
                    return ;
                  }
                  MM_proof_tree.pnAddParent(curNode, src);
                  if (typeof src === "number") {
                    return ;
                  }
                  if (src.TAG === /* Hypothesis */0) {
                    return ;
                  }
                  src.args.forEach(function (arg) {
                        if (Belt_Option.isNone(MM_proof_tree.pnGetProof(arg)) && Belt_Option.isNone(MM_proof_tree.pnGetDist(arg))) {
                          MM_proof_tree.pnSetDist(arg, newDist);
                          return Belt_MutableQueue.add(nodesToCreateParentsFor, arg);
                        }
                        
                      });
                }
                }(curNode,curExpr,newDist)));
          }
          
        }
      }
    }
    
  };
}

function proveStmtBottomUp(tree, expr, params, onProgress) {
  var rootExprs = MM_proof_tree.ptGetRootStmts(tree).map(function (stmt) {
        return stmt.expr;
      });
  var getParents = function (expr, dist) {
    var parents = findAsrtParentsWithNewVars(tree, expr, rootExprs, false, dist === 0 ? params.asrtLabel : undefined, true, dist === 0 && params.allowNewVars, undefined);
    if (dist === 0) {
      return parents;
    }
    var exprLen = expr.length;
    return parents.filter(function (parent) {
                if (typeof parent === "number") {
                  return true;
                }
                if (parent.TAG === /* Hypothesis */0) {
                  return true;
                }
                var frame = parent.frame;
                var args = parent.args;
                var argsAreCorrect = true;
                var numOfArgs = frame.hyps.length;
                var maxArgIdx = numOfArgs - 1 | 0;
                var argIdx = 0;
                while(argIdx <= maxArgIdx && argsAreCorrect) {
                  var arg = Caml_array.get(args, argIdx);
                  if (Caml_array.get(frame.hyps, argIdx).typ === /* E */1) {
                    var match = params.lengthRestriction;
                    var tmp;
                    switch (match) {
                      case /* No */0 :
                          tmp = true;
                          break;
                      case /* LessEq */1 :
                          tmp = MM_proof_tree.pnGetExpr(arg).length <= exprLen;
                          break;
                      case /* Less */2 :
                          tmp = MM_proof_tree.pnGetExpr(arg).length < exprLen;
                          break;
                      
                    }
                    argsAreCorrect = tmp;
                  }
                  argIdx = argIdx + 1 | 0;
                };
                return argsAreCorrect;
              });
  };
  proveBottomUp(tree, expr, getParents, params.maxSearchDepth, onProgress);
  return MM_proof_tree.ptGetOrCreateNode(tree, expr);
}

function proveStmt(tree, expr, jstf, bottomUpProverParams, onProgress) {
  if (bottomUpProverParams !== undefined) {
    proveStmtBottomUp(tree, expr, bottomUpProverParams, onProgress);
  } else if (jstf !== undefined) {
    proveWithJustification(tree, expr, jstf);
  } else {
    proveWithoutJustification(tree, expr);
  }
}

function makeExprToStr(ctx, ctxMaxVar) {
  if (!MM_context.isDebug(ctx)) {
    return ;
  }
  var intToSym = function (i) {
    if (i <= ctxMaxVar) {
      return MM_context.ctxIntToSymExn(ctx, i);
    } else {
      return "&" + String(i);
    }
  };
  return (function (expr) {
            return expr.map(intToSym).join(" ");
          });
}

function createProofTree(ctx, frms, parenCnt, addEssentials) {
  var ctxMaxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  var hyps = MM_context.getAllHyps(ctx);
  var tree = MM_proof_tree.ptMake(frms, hyps, ctxMaxVar, MM_context.getAllDisj(ctx), parenCnt, makeExprToStr(ctx, ctxMaxVar));
  if (addEssentials) {
    Belt_MapString.forEach(hyps, (function (label, hyp) {
            if (hyp.typ !== /* E */1) {
              return ;
            }
            var node = MM_proof_tree.ptGetOrCreateNode(tree, hyp.expr);
            MM_proof_tree.pnAddParent(node, {
                  TAG: /* Hypothesis */0,
                  label: label
                });
            MM_proof_tree.ptAddRootStmt(tree, {
                  label: label,
                  expr: hyp.expr,
                  justification: undefined
                });
          }));
  }
  return tree;
}

function proveFloatings(ctx, frms, stmts, parenCnt, param) {
  var tree = createProofTree(ctx, frms, parenCnt, false);
  stmts.forEach(function (stmt) {
        proveFloating(tree, MM_proof_tree.ptGetOrCreateNode(tree, stmt));
      });
  return tree;
}

function unifyAll(ctx, frms, stmts, parenCnt, bottomUpProverParams, onProgress, param) {
  var progressState = MM_progress_tracker.progressTrackerMutableMake(0.01, undefined, Belt_Option.map(onProgress, (function (onProgress, pct) {
              Curry._1(onProgress, "Unifying all: " + String(Math.round(pct * 100) | 0) + "%");
            })), undefined, undefined);
  var tree = createProofTree(ctx, frms, parenCnt, true);
  var numOfStmts = stmts.length;
  var maxStmtIdx = numOfStmts - 1 | 0;
  stmts.forEach(function (stmt, stmtIdx) {
        proveStmt(tree, stmt.expr, stmt.justification, stmtIdx === maxStmtIdx ? bottomUpProverParams : undefined, stmtIdx !== maxStmtIdx || Belt_Option.isNone(bottomUpProverParams) ? undefined : onProgress);
        MM_proof_tree.ptAddRootStmt(tree, stmt);
        MM_progress_tracker.progressTrackerMutableSetCurrPct(progressState, (stmtIdx + 1 | 0) / numOfStmts);
      });
  if (MM_context.isDebug(ctx)) {
    MM_proof_tree.ptGetStats(tree);
    stmts.map(function (stmt) {
          return MM_proof_tree.ptGetOrCreateNode(tree, stmt.expr);
        });
  }
  return tree;
}

exports.proveFloatings = proveFloatings;
exports.unifyAll = unifyAll;
/* MM_context Not a pure module */
